import { InfoOutlined } from "@mui/icons-material";
import styles from "./status-label.module.css";

export default function StatusLabel({ text }) {
  return (
    <div className={styles.statusLabel}>
      <InfoOutlined />
      <span>{text}</span>
    </div>
  );
}
